<template>
    <el-backtop :bottom="100">
        <div>
            <i class="el-icon-caret-top"></i>
        </div>
    </el-backtop>
</template>

<script>
export default {
    name: 'ShareTop',
}
</script>

<style scoped>

</style>
